<template>
  <div>
    <div v-if="readOnly" class="ql-container">
      <div class="ql-editor" style="overflow-wrap: anywhere; min-width: 100%; min-height: 20px;">
        <div v-html="typeof value == 'object' ? value.html : value"></div>
      </div>
    </div>
    <editor v-else ref="editor" v-bind="$attrs" :value="value" v-on="$listeners"></editor>
  </div>
</template>

<script>
import editor from './editor';
import Quill from 'quill';

export default {
  components: { editor },
  props: {
    readOnly: {
      type: Boolean,
      default: false
    },
    value: {
      type: [Object, String],
      default: () => {
        return {
          html: ''
        };
      }
    }
  },
  computed: {
    contentLength() {
      const value = this.value;
      if (value) {
        console.log('length', this.getLength());
        return this.getLength();
      } else {
        return 1;
      }
    }
  },
  methods: {
    setCaret($event) {
      // const newIndex = this.findIndex(prevLeft, direction);
      this.$refs.editor.setCaret($event);
    },
    setContents($event) {
      console.log('set contents!!!');
      this.$refs.editor.setContents($event);
    },
    toggleCodeBlock() {
      const length = this.getLength();
      const editor = this.$refs.editor.editor;
      const format = editor.getFormat(0, length);
      if (format['code-block']) {
        const text = editor.getText();
        editor.setText(text, 'user');
        console.log(text);
      } else {
        editor.formatText(0, length, 'code-block', !format['code-block'], 'user');
      }
    },
    getContents($event) {
      console.log('set contents!!!');
      return this.$refs.editor.getContents($event);
    },
    setSelection($event) {
      this.$refs.editor.editor.setSelection($event);
    },
    updateContents($event) {
      this.$refs.editor.updateContents($event);
    },
    focus($event) {
      this.$refs.editor.focus($event);
    },
    blur() {
      this.$refs.editor.editor.blur();
    },
    getLength() {
      return this.$refs.editor ? this.$refs.editor.editor.getLength() : 0;
    },
    async pasteSpecial(v) {
      const editor = this.$refs.editor.editor;
      const nDelta = editor.clipboard.convert(v);
      console.log(nDelta);
      var range = editor.getSelection(true);
      console.log(range);
      var Delta = Quill.import('delta');
      const oDelta = new Delta().retain(range.index);
      const combDelta = oDelta.concat(nDelta);
      const length = combDelta.length();
      editor.updateContents(combDelta);
      console.log(length);
      setTimeout(() => {
        editor.setSelection(100);
      }, 10);
      return true;
    }
  }
};
</script>

<style>

</style>
